import { useContext, useMemo } from 'react'
import { useRouteMatch } from 'react-router-dom'
import { PendingStatus } from '@components'
import { submissionContext, templateContext } from '@contexts'
import { useAppSelector } from '@redux/hooks'

interface HookReturn {
  requireApproval: boolean
}

/**
 * A template may require approval, or the submission status determines the required approval.
 */
interface UseSettingsRouterParams {
  id: string
}

export const useSettings = (): HookReturn => {
  const match = useRouteMatch<UseSettingsRouterParams>()
  const { id } = match.params
  const { byId: templatesById } = useContext(templateContext)
  const { byId: submissionsById } = useContext(submissionContext)
  const meta = useAppSelector(state => state.Datasets.datasetMetadataById[id])
  const submission = useMemo(() => submissionsById[id], [id, submissionsById])

  const requireApproval = useMemo(() => {
    const templateRequiresApproval = Boolean(
      templatesById?.[meta?.template_id]?.settings?.require_approval,
    )
    const isApprovalStatus =
      submission?.status === PendingStatus.REJECTED ||
      submission?.status === PendingStatus.AWAITING_APPROVAL
    return templateRequiresApproval || isApprovalStatus
  }, [templatesById, meta])

  return {
    requireApproval,
  }
}
